export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`relative flex overflow-hidden ${className}`} data-testid="marquee">
      <div className="flex shrink-0 animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display text-4xl font-bold uppercase tracking-tight md:text-6xl">
            <span className={i % 2 ? "stroke-text" : "text-cream"}>{t}</span>
            <span className="text-electric">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
